import type { SchemaField, SchemaForm } from "@/entities/schema";

export const extractSchemaLabels = (schema: SchemaForm) => {
  const fields: SchemaField[] = [
    ...(schema.fields ?? []),
    ...(schema.groups ?? []).flatMap((g) => g.fields ?? []),
  ];

  return Object.fromEntries(fields.map((field) => [field.model, field.label]));
};
